/*
 * $Id:: FilterActionButtons.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';

import { ReactComponent as CaretBottom } from '../../assets/images/caretBottom.svg';
import { t } from '../../providers';

const useStyles = makeStyles(() => ({
    actionButtonsArea: {
        '@media (max-width:960px)': {
            marginTop: '10px',
        },
    },
    textInput: {
        height: '2rem',
        minWidth: '9rem',
        border: '1px solid #CDCED9',
        borderRadius: '4px',
        backgroundColor: '#FFFFFF',
        marginLeft: '10px',
        marginRight: '0',
        '&.MuiInputBase-root.Mui-focused': {
            border: '1px solid #CDCED9',
            backgroundColor: '#FFFFFF',
        },
        '@media (max-width:960px)': {
            margin: '4px 8px 4px 0',
        },
    },
    disabledActionButton: {
        border: '1px solid #E7E7ED',
        '&:active': {
            border: '1px solid #E7E7ED',
        },
    },
    initiateServices: { width: '11rem' },
    exportAction: { width: '9rem' },
    buttonMargin: {
        marginRight: '10px',
    },
}));

const FilterActionButtons = ({ exportTypes, onInitiateServices, initiateServicesOptions = [], disableInitiateServices }) => {
    const classes = useStyles();

    return (
        <div className={classes.actionButtonsArea}>
            {onInitiateServices && !!initiateServicesOptions.length && (
                <Select
                    id={'initiate-eServices-input'}
                    className={`${classes.textInput} ${classes.initiateServices} ${classes.disabledActionButton}`}
                    displayEmpty
                    disabled={disableInitiateServices}
                    IconComponent={CaretBottom}
                    value={''}
                    renderValue={(_value) => {
                        return t('initiate.eservices');
                    }}
                    onChange={(e) => onInitiateServices(e.target.value)}>
                    {initiateServicesOptions.map((option, idx) => (
                        <MenuItem
                            id={`initiate-eServices-option-${idx}`}
                            key={`${option.key && option.key.toLowerCase()}_${idx}`}
                            value={option.key}
                            name={option.label}>
                            {t(option.label)}
                        </MenuItem>
                    ))}
                </Select>
            )}
            {exportTypes && !!exportTypes.length && (
                <Select
                    id={'export-results-input'}
                    className={`${classes.textInput} ${classes.exportAction}`}
                    displayEmpty
                    IconComponent={CaretBottom}
                    value={''}
                    renderValue={(_value) => {
                        return t('export.results');
                    }}>
                    <MenuItem selected disabled>
                        {t('export.results')}
                    </MenuItem>
                    {exportTypes.map((option, idx) => (
                        <MenuItem id={`export-results-option-${idx}`} key={`${option.label}_${idx}`} value={option.label} onClick={option.action}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Select>
            )}
        </div>
    );
};

export default FilterActionButtons;
